import { Skeleton, Split } from '@omnipresentgroup/design-system';

export const QuoteSkeleton = () => (
  <>
    <Split gap="64">
      <Skeleton height={14} />
      <Skeleton height={14} />
    </Split>
    <Split gap="64">
      <Skeleton height={14} />
      <Skeleton height={14} />
    </Split>
    <Split gap="64">
      <Skeleton height={14} />
      <Skeleton height={14} />
    </Split>
    <Split gap="64">
      <Skeleton height={14} />
      <Skeleton height={14} />
    </Split>
  </>
);
